<nav class="navbar navbar-expand-md navbar-light bg-light sticky-top">
  <div class="container">
    <div class="d-flex align-items-center">
      <a href="/" class="me-1">
        <img src="../../../assets/img/logo.png" alt="Logo" class="img-fluid" style="max-height: 30px" />
      </a>
      <a class="navbar-brand" href="/">
        <b>{{ navUser.name }}</b>
      </a>
    </div>

    <ul class="header-tabs d-flex align-items-center gap-2 mb-0 ms-n1">



      <li class="list-unstyled" *ngIf="currentTab !== 'home1'">
        <button type="button" class="btn btn-link px-2 py-1 fw-semibold text-dark text-decoration-none"
          (click)="selectTab('home1')">
          <span class="tab-glow-active px-3 py-0 rounded-pill bg-white text-dark small">
            Deals
            <img src="https://cdn-icons-gif.flaticon.com/19010/19010519.gif" alt="deals" width="32" height="32">
          </span>
        </button>
      </li>

      <li class="list-unstyled" *ngIf="currentTab !== 'home2'">
        <button type="button" class="btn btn-link px-2 py-1 fw-semibold text-dark text-decoration-none"
          (click)="selectTab('home2')">
          <span class="tab-glow-active px-3 py-0 rounded-pill bg-white text-dark small">
            Pubs
            <img src="https://cdn-icons-gif.flaticon.com/13121/13121484.gif" alt="Beer" width="32" height="32">
          </span>
        </button>
      </li>
    </ul>

    <div class="ms-auto d-flex align-items-center">
      <div class="dropdown" *ngIf="!isLoggedIn">

        <button class="btn btn-outline-dark rounded-pill px-3 py-1 fw-semibold me-2 login-button small"
          data-bs-toggle="dropdown">
          Sign up / Log in
        </button>
        <div class="dropdown-menu dropdown-menu-end p-0 shadow border-0" style="width: 380px; border-radius: 12px">
          <div class="bg-warning p-4" style="border-radius: 12px 12px 0 0">
            <h5 class="fw-bold mb-2">Get our best deals!</h5>
            <p class="mb-0">
              Join the FREE D&P Insider program and get personalized deals via
              email, text, or app alerts!
            </p>
          </div>
          <!-- White Bottom -->
          <div class="p-4 d-flex justify-content-between">
            <button class="btn btn-outline-dark rounded-pill px-4" routerLink="/login">
              Log in
              <span class="badge bg-dark text-light ms-2 rounded-pill">&gt;</span>
            </button>
            <button class="btn btn-outline-dark rounded-pill px-4" routerLink="/register">
              Sign up
              <span class="badge bg-dark text-light ms-2 rounded-pill">&gt;</span>
            </button>
          </div>
        </div>
      </div>
      <div class="dropdown">
        <button class="btn p-0 border-0" data-bs-toggle="dropdown">
          <div class="crown-box d-flex align-items-center justify-content-center" [class.logged-in]="isLoggedIn">
            <i class="fa-solid fa-crown" [ngClass]="isLoggedIn ? 'text-success' : 'text-warning'"></i>
          </div>
        </button>
        <ul class="dropdown-menu dropdown-menu-end shadow nav-dropdown-width">
          @for (navLink of visibleNavLinks; track navLink) {
          <li>
            <a class="dropdown-item navlink-light" [routerLink]="navLink.link">
              {{ navLink.text }}
            </a>
          </li>
          }
          <li *ngIf="isLoggedIn">
            <hr class="dropdown-divider">
          </li>
          <li *ngIf="isLoggedIn">
            <button class="dropdown-item navlink-light text-danger" (click)="logout()">
              Sign Out
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>